import { render, staticRenderFns } from "./InsightCard.vue?vue&type=template&id=0353e5e6&"
import script from "./InsightCard.vue?vue&type=script&lang=js&"
export * from "./InsightCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports